import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import ForgotPassword from "./components/ForgotPassword";
import AccountSettings from "./components/Accountsettings";
import { PRODUCT_SLUGS } from "./components/ProductAuthLayout";
import { ThemeProvider, useTheme } from "./ThemeContext";
import { WEBCHAT_CONFIG } from "./components/webchatConfig";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

function AppContent() {
  const { isDarkMode } = useTheme();

  // Initialize state from localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const stored = localStorage.getItem("isAuthenticated");
    return stored === "true";
  });

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  // Persist authentication state
  useEffect(() => {
    if (isAuthenticated && user) {
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");
    }
  }, [isAuthenticated, user]);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user");

    // Clear chat related data
    try {
      localStorage.removeItem(`chatHistory_${WEBCHAT_CONFIG.clientName}`);
      localStorage.removeItem(WEBCHAT_CONFIG.clientName);
      localStorage.removeItem("pinnedChats");
      localStorage.removeItem("external_id");
    } catch (e) {
      console.error("Error clearing chat data:", e);
    }
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/signup"
            element={
              !isAuthenticated ? (
                <Signup onSignup={handleLogin} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          {/* Product-branded login/signup, linked from the igr-consulting.com landing page */}
          {PRODUCT_SLUGS.flatMap((product) => [
            <Route
              key={`${product}-login`}
              path={`/${product}/login`}
              element={
                !isAuthenticated ? (
                  <Login onLogin={handleLogin} product={product} />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              }
            />,
            <Route
              key={`${product}-signup`}
              path={`/${product}/signup`}
              element={
                !isAuthenticated ? (
                  <Signup onSignup={handleLogin} product={product} />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              }
            />,
            <Route
              key={product}
              path={`/${product}`}
              element={<Navigate to={`/${product}/login`} replace />}
            />,
          ])}
          <Route
            path="/forgot-password"
            element={
              !isAuthenticated ? (
                <ForgotPassword />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/profile"
            element={
              isAuthenticated ? (
                <AccountSettings
                  user={user}
                  onLogout={handleLogout}
                  isDarkMode={isDarkMode}
                  onClose={() => window.location.href = "/dashboard"}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              <Navigate
                to={isAuthenticated ? "/dashboard" : "/login"}
                replace
              />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
      <ToastContainer position="top-right" autoClose={300} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
    </ThemeProvider>
  );
}

export default App;


